export default __webpack_public_path__ + "static/media/hokky-absensi.765de492.png";